import { render, staticRenderFns } from "./ApeironInviteInternal.vue?vue&type=template&id=5bb7f45c"
import script from "./ApeironInviteInternal.vue?vue&type=script&lang=js"
export * from "./ApeironInviteInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports